export default __webpack_public_path__ + "static/snowflakependantandring-983b41e1f375b75d5e9ddb8c9b3bac87.png";